import React, { useEffect, useContext } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { useState } from 'react';
import { CampaignChangeSalesTeam } from './CampaignChangeSalesTeam';
import {
    Card,
    CardActionArea,
    CardContent,
    CardHeader
} from "@mui/material";

export const Tools = () => {
  const toolbarContext = useContext(ToolbarContext);
  const [openWindow,setOpenWindow] = useState<string|null>(null);

  useEffect(() => {
      toolbarContext.setPrimary({
          primary: [],
          title: 'Tools',
          baseUrl: '/tools'
      });
  },[]);
  return (
    <div className="tools grid12">
      <Card className="grid12-3">
        <CardActionArea onClick={()=>{ setOpenWindow('change-sales-team')}}>
          <CardHeader title="Campaign - Change sales Team" sx={{paddingBottom:0}} variant="h5"/>
          <CardContent >
              Change a campaign sales team e.g. JKA to JAR.  This cannot be undone and will break any existing links to the campaign preview.
          </CardContent>
          </CardActionArea>
      </Card>
        <CampaignChangeSalesTeam open={openWindow=='change-sales-team'} close={()=>{ setOpenWindow(null)}}/>
    </div>
  );
}
